import styled from 'styled-components'

export const LandingBodyWrapper = styled.div`
  flex-grow: 1;
  background-color: #FAFBFF;
`